import { Action } from '@ngrx/store';

export const GENERATE_EXTRACT_SUCCESS = '[Extract] Generate Extract Success';

export class GenerateExtractSuccessAction implements Action {
  readonly identifier = new Date().getTime().toString();
  readonly type = GENERATE_EXTRACT_SUCCESS;

  constructor(public payload: { extractKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GenerateExtractSuccessAction.ts